import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { OorjitSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: OorjitSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: OorjitSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<OorjitSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderApiKey = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">API Key</label>
          <Controller
            control={control}
            rules={{
              required: 'API Key is required',
            }}
            name="apiKey"
            defaultValue={props.data?.apiKey}
            render={({ onChange, value, name }) => (
              <input
                type="password"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="API Key"
                name={name}
                value={value}
                onChange={onChange}
                id="apiKey"
              />
            )}
          />
          <ErrorMessage>{errors.apiKey?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBaseUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Base Url</label>
          <Controller
            control={control}
            rules={{
              required: 'Base Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name="baseUrl"
            defaultValue={props.data?.baseUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Base Url"
                name={name}
                value={value}
                onChange={onChange}
                id="baseUrl"
              />
            )}
          />
          <ErrorMessage>{errors.baseUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  // const renderWebsiteId = () => {
  //   return (
  //     <div className="col-12">
  //       <div className="form-group font-weight-semibold mb-3">
  //         <label className="font-sm text-uppercase">Website ID</label>
  //         <Controller
  //           control={control}
  //           rules={{
  //             required: 'Website ID is required',
  //           }}
  //           name="websiteId"
  //           defaultValue={props.data?.websiteId}
  //           render={({ onChange, value, name }) => (
  //             <input
  //               type="text"
  //               className="form-control rounded-sm font-weight-semibold"
  //               placeholder="Website ID"
  //               name={name}
  //               value={value}
  //               onChange={onChange}
  //               id="websiteId"
  //             />
  //           )}
  //         />
  //         <ErrorMessage>{errors.websiteId?.message}</ErrorMessage>
  //       </div>
  //     </div>
  //   );
  // };

  // const renderSubsiteId = () => {
  //   return (
  //     <div className="col-12">
  //       <div className="form-group font-weight-semibold mb-3">
  //         <label className="font-sm text-uppercase">Subsite ID</label>
  //         <Controller
  //           control={control}
  //           rules={{
  //             required: 'Subsite ID is required',
  //           }}
  //           name="subsiteId"
  //           defaultValue={props.data?.subsiteId}
  //           render={({ onChange, value, name }) => (
  //             <input
  //               type="text"
  //               className="form-control rounded-sm font-weight-semibold"
  //               placeholder="Subsite ID"
  //               name={name}
  //               value={value}
  //               onChange={onChange}
  //               id="subsiteId"
  //             />
  //           )}
  //         />
  //         <ErrorMessage>{errors.subsiteId?.message}</ErrorMessage>
  //       </div>
  //     </div>
  //   );
  // };

  // const renderLanguageIdEnglish = () => {
  //   return (
  //     <div className="col-12">
  //       <div className="form-group font-weight-semibold mb-3">
  //         <label className="font-sm text-uppercase">
  //           Language ID (English)
  //         </label>
  //         <Controller
  //           control={control}
  //           rules={{
  //             required: 'Language ID (English) is required',
  //           }}
  //           name="languageIdEnglish"
  //           defaultValue={props.data?.languageIdEnglish}
  //           render={({ onChange, value, name }) => (
  //             <input
  //               type="text"
  //               className="form-control rounded-sm font-weight-semibold"
  //               placeholder="Language ID (English)"
  //               name={name}
  //               value={value}
  //               onChange={onChange}
  //               id="languageIdEnglish"
  //             />
  //           )}
  //         />
  //         <ErrorMessage>{errors.languageIdEnglish?.message}</ErrorMessage>
  //       </div>
  //     </div>
  //   );
  // };

  // const renderLanguageIdArabic = () => {
  //   return (
  //     <div className="col-12">
  //       <div className="form-group font-weight-semibold mb-3">
  //         <label className="font-sm text-uppercase">Language ID (Arabic)</label>
  //         <Controller
  //           control={control}
  //           rules={{
  //             required: 'Language ID (Arabic) is required',
  //           }}
  //           name="languageIdArabic"
  //           defaultValue={props.data?.languageIdArabic}
  //           render={({ onChange, value, name }) => (
  //             <input
  //               type="text"
  //               className="form-control rounded-sm font-weight-semibold"
  //               placeholder="Language ID (Arabic)"
  //               name={name}
  //               value={value}
  //               onChange={onChange}
  //               id="languageIdArabic"
  //             />
  //           )}
  //         />
  //         <ErrorMessage>{errors.languageIdArabic?.message}</ErrorMessage>
  //       </div>
  //     </div>
  //   );
  // };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Oorjit Ecom Settings
        </h4>
        <div className="row gutter-10">
          {renderBaseUrl()}
          {renderApiKey()}
          {/* {renderWebsiteId()}
          {renderSubsiteId()}
          {renderLanguageIdEnglish()}
          {renderLanguageIdArabic()} */}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
